import axios from 'axios';

export const createStore = () => {
  return {
    year: '',
    address: '',
    location: [37.3595704, 127.105399],
    openModal: true,
    stores: [],
    setYear() {},
    isLoading: false,
    getIsLoading() {
      return this.isLoading;
    },
    setIsLoading(handle) {
      this.isLoading = handle;
    },
    setAddress(address) {
      this.address = address;
    },
    setLocation([lat, lng]) {
      this.location = [lat, lng];
    },
    setOpenModal(handle) {
      this.openModal = handle;
    },
    async getStores() {
      const { data } = await axios.get(
        'https://8oi9s0nnth.apigw.ntruss.com/corona19-masks/v1/storesByGeo/json',
        {
          params: {
            lat: this.location[0],
            lng: this.location[1],
            m: 5000
          }
        }
      );
      const { stores } = data;
      this.stores = stores;
      return this.stores;
    }
  };
};
